import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { invalidateConnectorQueries } from "@/lib/connector-queries";
import { supabase } from "@/lib/supabase";

/**
 * Refresh connector eligibility when the connector row changes.
 * Credential removal that never updates this row stays unknown until Test connection.
 */
export function useConnectorRowSubscription(orgId: string | null | undefined) {
  const queryClient = useQueryClient();
  useEffect(() => {
    if (!orgId) return;
    const channel = supabase
      .channel(`org-connectors-${orgId}`)
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: "connectors", filter: `org_id=eq.${orgId}` },
        () => invalidateConnectorQueries(queryClient, orgId),
      )
      .subscribe();
    return () => {
      void supabase.removeChannel(channel);
    };
  }, [orgId, queryClient]);
}
